import state from './state'
import mutations from './mutations'

const module = {
    namespaced: true,
    state,
    mutations
}

export default module
